import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import cx from 'classnames';
import { color } from 'styles/utils';
import { icon_pencil, icon_project_folder, icon_scan_camera } from 'components/base/images';
import CustomSpan from 'components/common/text/CustomSpan';
import { T } from 'components/common/text';
import { IconButton } from '@material-ui/core';
import { useQuickstartStore } from 'store/local/quickstart';
import { useQuickStart } from 'lib/hooks/quickstart/useQuickStart';

interface QuickMenuProps {
  scanBtnState: boolean;
  projectBtnState: boolean;
  editPatientBtnState: boolean;
  onClickQuickMenu: (type: 'scan' | 'project' | 'editPatient') => void;
}

function QuickMenu() {
  const {
    searchKeyword,
    selectedPatientCode,
    scanBtnState,
    scanButtonRef,
    projectButtonRef,
    projectBtnState,
    editPatientBtnState,
    isOpenSearchResult,
  } = useQuickstartStore();

  const { handleClickQuickMenu, installedAppList } = useQuickStart();
  const { ipcRenderer } = window;
  const [isConnect, setIsConnect] = useState<boolean>(false);

  // useEffect(() => {
  //   if (ipcRenderer) {
  //     ipcRenderer.send('installedAppList', {});
  //     ipcRenderer.on('installedAppListRes', (e: any, data: any) => {
  //       // setInstalledList(data.appList);
  //       const connectScan = data.appList?.find((appName: any) => appName === 'APP_SCAN_IOS');
  //       setIsConnect(!!connectScan);
  //       // setIsConnect(true);
  //     });
  //   }
  // }, []);

  useEffect(() => {
    if (installedAppList.length > 0) {
      const connectScan = installedAppList?.find((appName: any) => appName === 'APP_SCAN_IOS');
      setIsConnect(!!connectScan);
    }
  }, [installedAppList]);

  return (
    <StyledQuickMenu data-component-name="QuickMenu">
      <div className="quickMenu__container">
        <div className="quickMenu__container_box">
          <div ref={scanButtonRef}>
            <MenuButton
              buttonState={!(!scanBtnState || !isConnect)}
              type="scan"
              onClick={() => {
                if (!scanBtnState || !isConnect) return;
                handleClickQuickMenu(
                  'scan',
                  !!isOpenSearchResult ? '' : selectedPatientCode,
                  searchKeyword,
                );
              }}
            />
          </div>
          {!scanBtnState || (!isConnect && <div className="quickMenu__container_dim"></div>)}
        </div>
        <div className="quickMenu__container_box">
          <div ref={projectButtonRef}>
            <MenuButton
              buttonState={projectBtnState}
              type="project"
              onClick={() => {
                if (!projectBtnState) return;
                handleClickQuickMenu(
                  'project',
                  !!isOpenSearchResult ? '' : selectedPatientCode,
                  searchKeyword,
                );
              }}
            />
          </div>
        </div>
        <div className="quickMenu__container_box">
          <div>
            <MenuButton
              buttonState={editPatientBtnState}
              type="patient"
              onClick={() => {
                if (!editPatientBtnState) return;
                handleClickQuickMenu('editPatient', selectedPatientCode);
              }}
            />
          </div>
        </div>
      </div>
    </StyledQuickMenu>
  );
}

const StyledQuickMenu = styled.div<{}>`
  border-left: 1px solid ${color.border_line};
  padding-left: 30px;
  margin-top: 41px;
  .quickMenu__container {
    display: flex;
    flex-direction: column;
    row-gap: 10px;
    .quickMenu__container_box {
      position: relative;
      .quickMenu__container_dim {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: transparent;
      }
    }
  }
`;

function MenuButton({
  buttonState,
  type,
  onClick,
}: {
  buttonState: boolean;
  type: 'scan' | 'project' | 'patient';
  onClick: () => void;
}) {
  const [isHover, setIsHover] = useState<boolean>(false);
  return (
    <StyledMenuButton
      data-component-name="MenuButton"
      className={cx(`${type}`, { disabled: !buttonState })}
      onMouseEnter={() => {
        if (!buttonState) return;
        setIsHover(true);
      }}
      onMouseLeave={() => {
        if (!buttonState) return;
        setIsHover(false);
      }}
      onClick={onClick}
    >
      <div
        className={cx('menuButton__button_box main', {
          hidden: !!isHover,
          column: type !== 'patient',
        })}
      >
        <div className="main_title_wrapper">
          <CustomSpan fontColor="#fff" fontSize={40} fontWeight={500}>
            {type === 'scan' && <T>PROCESS_SCAN</T>}
            {type === 'project' && <T>GLOBAL_PROJECT</T>}
            {type === 'patient' && <T>PATIENT_INFO_TITLE</T>}
          </CustomSpan>
          <CustomSpan fontColor="#fff" fontSize={18} fontWeight={400}>
            {type === 'scan' && <T>GLOBAL_START_SCAN</T>}
            {type === 'project' && <T>GLOBAL_CREATE_PROJECT</T>}
            {type === 'patient' && <T>GLOBAL_PATIENT_EDIT</T>}
          </CustomSpan>
        </div>

        <div className="main_icon_wrapper">
          <div className={`main_icon_box icon_${type}`}>
            <div className={`main_icon icon_${type}`}>
              {type === 'scan' && <img src={icon_scan_camera} />}
              {type === 'project' && <img src={icon_project_folder} />}
              {type === 'patient' && <img src={icon_pencil} />}
            </div>
          </div>
        </div>
      </div>
      {/*  */}
      <IconButton
        className={cx('menuButton__button_box_wrapper', {
          hidden: !isHover,
        })}
      >
        <div className={cx('menuButton__button_box hover column', { hidden: !isHover })}>
          <div className="hover_description_wrapper">
            <CustomSpan fontColor="#fff" fontSize={16} fontWeight={600}>
              {type === 'scan' && <T>QUICKSTART_HOVER_SCAN</T>}
              {type === 'project' && <T>QUICKSTART_HOVER_PROJECT</T>}
              {type === 'patient' && <T>QUICKSTART_HOVER_PATIENT</T>}
            </CustomSpan>
          </div>
          <div className="hover_button_name">
            <CustomSpan fontColor="#fff" fontSize={16} fontWeight={600}>
              {type === 'scan' && <T>PROCESS_SCAN</T>}
              {type === 'project' && <T>GLOBAL_PROJECT</T>}
              {type === 'patient' && <T>PATIENT_INFO_TITLE</T>}
            </CustomSpan>
          </div>
        </div>
      </IconButton>
    </StyledMenuButton>
  );
}

const StyledMenuButton = styled.div<{}>`
  width: 360px;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.16);
  border-radius: 10px;
  display: flex;
  background-color: #25256f;

  &.scan,
  &.project {
    height: 342px;
    flex-direction: column;
  }
  &.patient {
    height: 132px;
  }
  &.disabled {
    background-color: #ccccd4;
  }

  &:not(.disabled) {
    &:hover {
      cursor: pointer;
      background-color: #0a164a;
    }
  }

  .menuButton__button_box_wrapper {
    width: 100%;
    height: 100%;
    padding: 0;
    text-align: initial;
    border-radius: 10px;
    .MuiIconButton-label {
      width: 100%;
      height: 100%;
    }
  }

  .menuButton__button_box {
    border-radius: 10px;
    width: 100%;
    height: 100%;
    display: flex;
    padding: 30px;

    &.column {
      flex-direction: column;
    }
    justify-content: space-between;

    &.hidden {
      display: none;
    }
  }

  .main {
    .main_title_wrapper {
      display: flex;
      flex-direction: column;
      row-gap: 5px;
    }
    .main_icon_wrapper {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      .main_icon_box {
        &:not(.icon_patient) {
          padding: 30px;
          border-radius: 50%;
          background-color: rgba(255, 255, 255, 0.15);
        }
      }

      .main_icon {
        &.icon_scan,
        &.icon_project {
          width: 60px;
          height: auto;
        }
        &.icon_patient {
          width: 40px;
          height: auto;
        }
      }
    }
  }

  .hover {
    .hover_description_wrapper {
      padding-bottom: 20px;
      border-bottom: 1px solid #fff;
    }
    .hover_button_name {
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
  }
`;

export default React.memo(QuickMenu);
